import React, { useState, useContext } from 'react'

import imgModalKeys from '../../../assets/images/fondoModalKeys.png'

import ButtonClose from '../../atoms/button-close/button-close'
import Button from '../../atoms/button/button'
import CompetitionService from '../../../shared-campaign/services/competition'

import { concourseId, gameId } from '../../../constants/activity-constants'
import GameServices from '../../../services/game-service'
import userSessionStorage from '../../../utils/userSessionStorage'

import { Context } from '../../../context/app-context'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import { jsonToHash } from '../../../utils/crypto'

import './modalKeys.scss'
import { text_replica_modalKeys1, text_replica_modalKeys2 } from './replica-modalKeys'

import { LOCALE } from '../../../constants/activity-constants'

const arg = LOCALE === 'es-AR'

const ModalKeys = ({ close, firstKey, firstPromotionalKey }) => {
  const { dispatch } = useContext(Context)

  const [errorMessage, setErrorMessage] = useState({
    status: '',
    message: '',
  })
  const [isLoadingPoints, setIsLoadingPoints] = useState(false)
  const [myKey, setMyKey] = useState('')

  const session = new userSessionStorage()
  const userInfo = session.getUserInfo()

  const handleErrorMessage = (status, message) => {
    setErrorMessage({
      status: status,
      message: message,
    })
    setTimeout(() => {
      setErrorMessage('')
    }, 6000)
  }

  const handleDataLayer = async error => {
    pushEventData({
      event: 'Interacciones_Clave_UCole',
      action: error ? 'view' : 'click',
      label: error
        ? '*La clave que ingresaste ya fue registrada, o no es válida.'
        : 'Enviar',
      user_data: userInfo && [
        await jsonToHash({
          nombre: userInfo.name,
          apellido: userInfo.lastName,
          celular: userInfo.cellPhone,
          correo: userInfo.email,
          ciudad: userInfo.location.cityName,
          departamento: userInfo.location.countryStateName,
          pais: userInfo.countryName,
        }),
      ],
      log_status: userInfo ? 'Yes' : 'Not',
    })
  }

  const handleAquirePoints = async e => {
    if (isLoadingPoints) {
      return null
    }
    e.preventDefault()

    if (myKey === '') {
      handleErrorMessage('error', 'Ingresa primero una clave')
      return
    }

    if (myKey.length < 10) {
      handleErrorMessage('error', 'La clave debe ser mínimo de 10 caracteres')
      return
    }

    if (myKey.length === 10) {
      setIsLoadingPoints(true)
      setErrorMessage('')
      let redeemRes = await CompetitionService.postRedeemKeyWithoutPoints(
        concourseId,
        {
          activity: 'universo-cole',
          key: { code: myKey },
          country: parseInt(process.env.COUNTRY_CODE),
        }
      )

      if (redeemRes.status === 200) {
        let tokenId = session.getToken()?.idToken
        const config = {
          headers: tokenId
            ? {
                Authorization: tokenId,
              }
            : undefined,
        }

        const payload = {
          totalLives: firstPromotionalKey
            ? firstKey > 1
              ? 3
              : 5
            : firstKey === 0
            ? 5
            : 3,
          code: myKey,
        }

        GameServices.postLife(gameId, payload, config).then(res => {
          if (res.status === 200) {
            handleDataLayer()
            setIsLoadingPoints(false)
            handleErrorMessage('sucess', res.userMessage)
            setMyKey('')
            dispatch({ type: 'clear-modal' })
            window.location.reload()
          } else {
            handleDataLayer(true)
            handleErrorMessage('error', res.userMessage)
            setIsLoadingPoints(false)
            setMyKey('')
          }
        })
      } else {
        handleDataLayer(true)
        handleErrorMessage('error', redeemRes.userMessage)
        setIsLoadingPoints(false)
        setMyKey('')
      }
    }

    if (myKey.length > 10) {
      //clave promocional de 12
      setIsLoadingPoints(true)
      setErrorMessage('')
      let tokenId = session.getToken()?.idToken
      const config = {
        headers: tokenId
          ? {
              Authorization: tokenId,
            }
          : undefined,
      }

      let promotionalKeyRes = await GameServices.postPromotionalKey(
        {
          competitionId: concourseId,
          key: { code: myKey },
        },
        config
      )

      if (promotionalKeyRes.status === 200) {
        let tokenId = session.getToken()?.idToken
        const config = {
          headers: tokenId
            ? {
                Authorization: tokenId,
              }
            : undefined,
        }

        const payload = {
          totalLives: 10,
          code: myKey,
        }

        GameServices.postLife(gameId, payload, config).then(res => {
          if (res.status === 200) {
            handleDataLayer()
            setIsLoadingPoints(false)
            handleErrorMessage('sucess', res.userMessage)
            setMyKey('')
            dispatch({ type: 'clear-modal' })
            window.location.reload()
          } else {
            handleDataLayer(true)
            handleErrorMessage('error', res.userMessage)
            setIsLoadingPoints(false)
            setMyKey('')
          }
        })
      } else {
        handleDataLayer(true)
        handleErrorMessage('error', promotionalKeyRes.userMessage)
        setIsLoadingPoints(false)
        setMyKey('')
      }
    }
  }

  return (
    <div className="f-modalKeys-container">
      <div className="f-modalKeys-container__wrapper">
        <ButtonClose onClick={close} />
        <figure className="f-modalKeys-container__figure">
          <img
            className="f-modalKeys-container__image"
            src={imgModalKeys}
            alt="fondo espacial del modal lo sentimos"
          />
        </figure>
        <section className="f-modalKeys-container__infoLogin">
          {firstKey <= 3 ? (
            <>
              <h2>
                ¡Bienvenida al <br />
                <b> Universo Nosotras!</b>
              </h2>
              <p>
                {text_replica_modalKeys1}
              </p>
            </>
          ) : (
            <>
              <h2>
                <b>¡Ups!</b>
                <br />
                Se acabaron tus vidas
              </h2>
              <p>
                {text_replica_modalKeys2}
                <br /> <br />
                <b className="f-pink">
                  1. Ingresa nuevas claves personales de cualquier producto
                  Nosotras.{' '}
                </b>
                Recuerda que las claves que anteriormente habías ingresado en
                NosotrasOnline, no se encuentran habilitadas para esta
                actividad. ¡No olvides conservar todos los empaques!
                <br />
                <br />
                <b className="f-pink">2. Si Nosotras ya visitó tu colegio, </b>
                recibiste una clave especial que te da 10 vidas para que
                empieces a jugar. ¡No lo dejes pasar!
              </p>
            </>
          )}

          <input
            type="text"
            placeholder={arg ? `Ingresá Tu clave`: `Ingresa Tu clave`}
            id="keys"
            name="keys"
            value={myKey}
            maxLength="12"
            onChange={e => {
              setMyKey(e.target.value)
            }}
          />
          {errorMessage.message && (
            <span
              className={`f-errorMessage ${
                errorMessage.status === 'sucess' && 'f-sucess'
              }`}
            >
              {errorMessage.message}
            </span>
          )}
          <Button
            disabled={isLoadingPoints}
            loading={isLoadingPoints}
            onClick={e => handleAquirePoints(e)}
            className="f-buttonKeys"
          >
            Enviar
          </Button>
        </section>
      </div>
    </div>
  )
}

export default ModalKeys
